document.addEventListener('DOMContentLoaded', function () {
  const burger = document.getElementById('burgerToggle');
  const nav = document.getElementById('headerNav');

  if (!burger || !nav) return;

  function openNav() {
    nav.classList.add('open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
  }

  function closeNav() {
    nav.classList.remove('open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
  }

  burger.addEventListener('click', function (e) {
    e.stopPropagation();
    nav.classList.contains('open') ? closeNav() : openNav();
  });

  document.addEventListener('click', function (e) {
    if (nav.classList.contains('open') && !nav.contains(e.target) && !burger.contains(e.target)) {
      closeNav();
    }
  });

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  // Close when notification panel opens
  document.getElementById('notificationToggle')?.addEventListener('click', closeNav);
});
